// prevents unauthenticated or unauthorized users from accessing restricted routes
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { AppError } from '@models/appError';
import {
  ApiEndpointsService,
  ApiHttpErrorService,
  ApiHttpService,
  RouteNavigationService,
  ToastService
} from '@services/index';
import { take } from 'rxjs/operators';
import { ApiResponse } from '../_models/ApiResponse/apiResponse';

// Makes sure their is a current tenant
// before allowing navigation to the login component
@Injectable({ providedIn: 'root' })
export class VerifiyEmailGuard implements CanActivate {
  constructor(
    private toastService: ToastService,
    private routeNavService: RouteNavigationService,
    private httpService: ApiHttpService,
    private endpointsService: ApiEndpointsService,
    private httpErrorService: ApiHttpErrorService
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const token = route.queryParams['token'];

    if (token === '' || token === null || token === undefined) {
      return false;
    }

    this.httpService
      .post<ApiResponse<number>>(this.endpointsService.getConfirmRegInfo(), {
        token,
      })
      .pipe(take(1))
      .subscribe(
        () => true,
        (error: AppError) => {
          this.httpErrorService.handle(error);
          this.routeNavService.tenantAuthPage();
          return false;
        }
      );
  }
}
